export const EMPRESA_QUERY_KEY = 'empresa';

export function parseEmpresaId(value) {
  if (value == null || value === '') return null;
  const id = Number(value);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function getEmpresaIdFromUrl(href = window.location.href) {
  try {
    const url = new URL(href, window.location.origin);
    return parseEmpresaId(url.searchParams.get(EMPRESA_QUERY_KEY));
  } catch {
    return null;
  }
}

export function pathWithEmpresa(path, empresaId) {
  if (!empresaId) return path;

  const hashIndex = path.indexOf('#');
  const hash = hashIndex >= 0 ? path.slice(hashIndex) : '';
  const withoutHash = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
  const [pathname, search = ''] = withoutHash.split('?');
  const params = new URLSearchParams(search);
  params.set(EMPRESA_QUERY_KEY, String(empresaId));
  const qs = params.toString();
  return `${pathname}${qs ? `?${qs}` : ''}${hash}`;
}

export function setEmpresaIdInUrl(empresaId, { pathname = window.location.pathname, replace = true } = {}) {
  const url = new URL(window.location.href);
  url.pathname = pathname;

  if (empresaId) {
    url.searchParams.set(EMPRESA_QUERY_KEY, String(empresaId));
  } else {
    url.searchParams.delete(EMPRESA_QUERY_KEY);
  }

  const next = `${url.pathname}${url.search}${url.hash}`;
  const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (next === current) return next;

  if (replace) {
    window.history.replaceState({}, '', next);
  } else {
    window.history.pushState({}, '', next);
  }

  return next;
}

export function clearEmpresaFromUrl({ pathname = '/', replace = true } = {}) {
  return setEmpresaIdInUrl(null, { pathname, replace });
}
